import React from "react";
import { Box } from "@mui/system";
import { QueryDateSelector } from "components/queries/queryBuilder/dialogParts/QueryDateSelector";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export interface TemplateSearchDateRangeProps {
  startDate: string | undefined;
  endDate: string | undefined;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  minDate?: dayjs.Dayjs | undefined;
}

export function TemplateSearchDateRange(props: TemplateSearchDateRangeProps) {
  const { i18n } = useTranslation();

  const { startDate, endDate, setStartDate, setEndDate } = props;

  return (
    <Box sx={{display: "inline"}}>
      <QueryDateSelector
        minDate={props.minDate}
        useSimpifiedRelativeDates={true}
        onChange={setStartDate}
        value={startDate || null}
        isDateInclusive={true}
      />
      <Box sx={{display:"inline-block", mr: 1, ml: 1}}>{i18n.t("to")}</Box>
      <QueryDateSelector
        useSimpifiedRelativeDates={true}
        includeNowOption={true}
        onChange={setEndDate}
        value={endDate || "now"}
      />
    </Box>
  );
}